export default __webpack_public_path__ + "static/media/mobile-photo-1.627a9f75.jpg";